import React from 'react'

const Loader = () => {
  return (
    <div className="dots"></div>
  )
}

export default Loader